import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cm-rpp',
  templateUrl: './rpp.component.html',
  styleUrls: ['./rpp.component.css']
})
export class RppComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
